import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteHoliday } from '../../../../actions';

const DeleteHolidayButton = ({ holidayId, dispatchDeleteHoliday }) => {
  const [showWarningModal, setShowWarningModal] = useState(false);

  const closeModal = () => setShowWarningModal(false);

  const handleDelete = () => {
    dispatchDeleteHoliday(holidayId);
    closeModal();
  };

  return (
    <>
      <ConfirmationModal
        show={showWarningModal}
        onClickConfirm={handleDelete}
        onClickCancel={closeModal}
      />
      <Button
        color="danger"
        onClick={() => setShowWarningModal(true)}
        className="ml-2"
      >
        Eliminar
      </Button>
    </>
  );
};

DeleteHolidayButton.propTypes = {
  holidayId: PropTypes.string.isRequired,
  dispatchDeleteHoliday: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchDeleteHoliday: deleteHoliday,
};

export default connect(null, mapDispatchToProps)(DeleteHolidayButton);